import { Component, input, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'aura-password-checker',
  templateUrl: './password-checker.component.html',
  styleUrls: ['./password-checker.component.css'],
  imports: [ReactiveFormsModule, MatFormFieldModule, MatIconModule, MatInputModule, MatButtonModule],
})
export class AuraInputPasswordCheckerComponent {
  control = input.required<FormControl<string | null>>();
  id = input<string>('password');
  label = input.required<string>();
  maxlength = input.required<number>();
  readonly = input.required<boolean>();
  showPasswordStrength = input.required<boolean>();
  placeholder = input<string>('');

  type = input<'text' | 'password' | 'number'>('password');

  hasRightLength = false;
  hasLowercase = false;
  hasUppercase = false;
  hasSpecialChar = false;
  hasUpperOrNumber = false;
  hasMinLength = false;
  isFocused = signal(false);

  checkPasswordStrength(): void {
    const val = this.control().value || '';
    this.hasLowercase = /[a-z]/.test(val);
    this.hasUppercase = /[A-Z]/.test(val);
    this.hasSpecialChar = /[^A-Za-z0-9]/.test(val);
    this.hasUpperOrNumber = /[A-Z0-9]/.test(val);
    this.hasRightLength = val.length <= this.maxlength() && val.length >= 8;
  }

  onFocus(): void {
    this.isFocused.set(true);
  }

  onBlur(): void {
    this.isFocused.set(false);
  }
}
